import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
  inject,
} from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { NotificationService } from 'src/app/shared/services/notification/notification.service';
import { Notification } from '../../types/notifications/Notification';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [IconComponent, CommonModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.css',
})
export class NotificationsComponent implements OnInit, OnDestroy {
  showPanel = false;
  hasNew = false;
  notifications: Notification[] = [];
  subscriptions?: Subscription[] = [];

  private notificationService = inject(NotificationService);
  private router = inject(Router);

  ngOnInit(): void {
    // this.startNotifications();
  }

  togglePanel(event?: Event): void {
    if (event) event.stopPropagation();
    this.showPanel = !this.showPanel;
    if (this.showPanel) {
      this.notificationService.hasNewNotifications = false;
    }
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.showPanel = false;
  }

  startNotifications = () => {
    if (this.subscriptions?.length) {
      this.subscriptions.forEach((sub) => {
        sub.unsubscribe();
      });
      this.subscriptions = [];
    }
    this.notificationService.stopPolling(true);

    const polling = this.notificationService
      .startPollingNotifications()
      .subscribe({
        next: (res) => {
          this.notifications = res.data;
        },
      });
    const hasNew = this.notificationService.hasNewNotifications$.subscribe({
      next: (flag) => (this.hasNew = flag),
    });
    this.subscriptions = this.subscriptions?.concat(polling, hasNew);
  };

  onClickNotification = (notification: Notification) => {
    this.notificationService.markAsRead(notification.uId).subscribe({
      next: (res) => {
        this.startNotifications();
        if (notification.url) {
          this.router.navigate([notification.url]);
        }
      },
      error: () => {
        this.startNotifications();
        if (notification.url) {
          this.router.navigate([notification.url]);
        }
      },
    });
  };

  ngOnDestroy(): void {
    this.notificationService.stopPolling();
  }
}
